export const TAB_OPTIONS = {
  SECTION: 'SECTION',
  TEMPLATE: 'TEMPLATE',
  SNIPPET: 'SNIPPET',
  RECENTNOTES: 'RECENTNOTES',
  LABS: 'LABS',
}

export const noteAccessErrorMessage =
  'This provider cannot start or sign the note because they are not the rendering provider and this is not a shared service.'

export const privateNoteErrorMessage =
  'This note is strictly confidential and viewable solely by the original author.'

export const sspOpenNoteErrorMessage =
  'The Shared Service Provider cannot start a note for this charge.'
